// frontend/src/pages/upgrade/payment.services.js
import { apiService } from "../../app.service";

export const paymentApi = apiService.injectEndpoints({
  endpoints: (builder) => ({
    // ✅ Get Pro upgrade pricing
    getProPricing: builder.query({
      query: () => ({
        url: "/payment/pricing",
      }),
      providesTags: ["ProPricing"],
    }),

    // ✅ Create Pro upgrade payment
    createProUpgradePayment: builder.mutation({
      query: (data) => ({
        url: "/payment/create-pro-payment",
        method: "POST",
        body: data,
      }),
      invalidatesTags: ["ProPricing"],
    }),

    // ✅ Create Add Location Payment (legacy card-entry)
    createAddLocationPayment: builder.mutation({
      query: (data) => ({
        url: "/payment/create-add-location-payment",
        method: "POST",
        body: data,
      }),
      invalidatesTags: ["ProPricing"],
    }),

    // Confirm add location on existing Stripe subscription (card on file)
    confirmAddLocation: builder.mutation({
      query: (data) => ({
        url: "/payment/confirm-add-location",
        method: "POST",
        body: data,
      }),
      invalidatesTags: ["ProPricing"],
    }),

    // ✅ Create Add Printer Payment
    createAddPrinterPayment: builder.mutation({
      query: (data) => ({
        url: "/payment/create-add-printer-payment",
        method: "POST",
        body: data,
      }),
      invalidatesTags: ["ProPricing", "SuppliesOrders"],
    }),

    // ✅ Create Add Printer Rolls Payment
    createAddPrinterRollsPayment: builder.mutation({
      query: (data) => ({
        url: "/payment/create-add-printer-rolls-payment",
        method: "POST",
        body: data,
      }),
      invalidatesTags: ["ProPricing", "SuppliesOrders"],
    }),

    // Charge supplies with subscription card on file
    confirmSuppliesPayment: builder.mutation({
      query: (data) => ({
        url: "/payment/confirm-supplies-payment",
        method: "POST",
        body: data,
      }),
      invalidatesTags: ["ProPricing", "SuppliesOrders"],
    }),

    // ✅ Check location status
    checkLocationStatus: builder.query({
      query: (paymentIntentId) => ({
        url: `/payment/check-location-status/${paymentIntentId}`,
      }),
    }),

    // ✅ Check printer status
    checkPrinterStatus: builder.query({
      query: (paymentIntentId) => ({
        url: `/payment/check-printer-status/${paymentIntentId}`,
      }),
    }),

    // ✅ Check printer rolls status
    checkPrinterRollsStatus: builder.query({
      query: (paymentIntentId) => ({
        url: `/payment/check-printer-rolls-status/${paymentIntentId}`,
      }),
    }),

    // Last supplies orders (for address prefill / history)
    listMySuppliesOrders: builder.query({
      query: () => ({
        url: "/payment/supplies-orders",
      }),
      providesTags: ["SuppliesOrders"],
    }),
  }),
});

export const {
  useGetProPricingQuery,
  useCreateProUpgradePaymentMutation,
  useCreateAddLocationPaymentMutation,
  useConfirmAddLocationMutation,
  useCreateAddPrinterPaymentMutation,
  useCreateAddPrinterRollsPaymentMutation,
  useConfirmSuppliesPaymentMutation,
  useCheckLocationStatusQuery,
  useCheckPrinterStatusQuery,
  useCheckPrinterRollsStatusQuery,
  useListMySuppliesOrdersQuery,
} = paymentApi;